export const STATUSES = [
  { value: "pending_approval", label: "Pending Approval" },
  { value: "new", label: "New" },
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
  { value: "declined", label: "Declined" },
  { value: "expired", label: "Expired" },
];

export const STATUS_STYLES = {
  pending_approval: "bg-amber-50 text-amber-800 border-amber-200",
  new: "bg-blue-50 text-blue-700 border-blue-200",
  in_progress: "bg-amber-50 text-amber-700 border-amber-200",
  completed: "bg-green-50 text-green-700 border-green-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
  declined: "bg-slate-100 text-slate-600 border-slate-200",
  expired: "bg-slate-100 text-slate-500 border-slate-200",
};

export const STATUS_LABEL = {
  pending_approval: "Pending Approval",
  new: "New",
  in_progress: "In Progress",
  completed: "Completed",
  cancelled: "Cancelled",
  declined: "Declined",
  expired: "Expired",
};

export const JOB_TYPES = [
  { value: "repair", label: "Repair" },
  { value: "installation", label: "Installation" },
];

export const AD_SOURCES = [
  { value: "cash", label: "Cash" },
  { value: "online", label: "Online" },
  { value: "warranty", label: "Warranty Company" },
];

export const APPLIANCE_TYPES = [
  { value: "refrigerator", label: "Refrigerator" },
  { value: "washer", label: "Washer" },
  { value: "dryer", label: "Dryer" },
  { value: "dishwasher", label: "Dishwasher" },
  { value: "stove", label: "Stove" },
  { value: "commercial", label: "Commercial" },
];

export const MANUFACTURERS = [
  { value: "ge", label: "GE" },
  { value: "whirlpool", label: "Whirlpool" },
  { value: "samsung", label: "Samsung" },
  { value: "lg", label: "LG" },
  { value: "frigidaire", label: "Frigidaire" },
  { value: "maytag", label: "Maytag" },
  { value: "other", label: "Other" },
];

export function findLabel(list, value) {
  return list.find((x) => x.value === value)?.label || value;
}

export function formatDateTime(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function formatDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (isNaN(d.getTime())) return "—";
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}
